import DetailPageModalComponent from '../components/DetailPageModal.js';
import MarketPriceModalComponent from '../components/MarketPriceModal.js';
import DetailPageModalMapComponent from '../components/DetailPageModalMap.js';
import DetailPageModalSimilarListingsComponent from '../components/DetailPageModalSimilarListings.js';
import GalleryThumbnailsComponent from '../components/GalleryThumbnails.js';
import DeveloperDetailMapComponent from '../components/DeveloperDetailMap.js';
import MarketPriceComponent from '../components/MarketPrice.js';
import MortgageSimulatorComponent from '../components/Mortgage/MortgageSimulator.js';
import MortgageCalculatorComponent from '../components/Mortgage/MortgageCalculator.js';
import MortgagePageCalculatorAndSimulatorComponent from '../components/Mortgage/MortgagePageCalculatorAndSimulator.js';
import MortgagePageLeadFormComponent from '../components/Mortgage/MortgagePageLeadForm.js';
import MortgageProductComponent from '../components/Mortgage/MortgageProduct.js';
import MortgageFormComponent from '../components/Mortgage/MortgageForm.js';
import RainbowPriceChartComponent from '../components/RainbowPriceChart.js';
import PriceEvolutionChartComponent from '../components/PriceEvolutionChart.js';
import DetailsTabsComponent from '../components/DetailsTabs.js';
import MarketTrendsComponent from '../components/MarketTrends.js';
import ListingPriceHistoryChart from '../components/ListingPriceHistoryChart.js';

const Alpine = window.Alpine;

Alpine.data('DetailPageModalComponent', DetailPageModalComponent);
Alpine.data('MarketPriceModalComponent', MarketPriceModalComponent);
Alpine.data('DetailsTabsComponent', DetailsTabsComponent);
Alpine.data('DetailPageModalMapComponent', DetailPageModalMapComponent);
Alpine.data('DetailPageModalSimilarListingsComponent', DetailPageModalSimilarListingsComponent);
Alpine.data('GalleryThumbnailsComponent', GalleryThumbnailsComponent);
Alpine.data('DeveloperDetailMapComponent', DeveloperDetailMapComponent);
Alpine.data('MarketPriceComponent', MarketPriceComponent);
Alpine.data('MortgageSimulatorComponent', MortgageSimulatorComponent);
Alpine.data('MortgageCalculatorComponent', MortgageCalculatorComponent);
Alpine.data('MortgagePageCalculatorAndSimulatorComponent', MortgagePageCalculatorAndSimulatorComponent);
Alpine.data('MortgagePageLeadFormComponent', MortgagePageLeadFormComponent);
Alpine.data('MortgageProductComponent', MortgageProductComponent);
Alpine.data('MortgageFormComponent', MortgageFormComponent);
Alpine.data('RainbowPriceChartComponent', RainbowPriceChartComponent);
Alpine.data('PriceEvolutionChartComponent', PriceEvolutionChartComponent);
Alpine.data('MarketTrendsComponent', MarketTrendsComponent);
Alpine.data('ListingPriceHistoryChart', ListingPriceHistoryChart);
